export default "__VITE_ASSET__9b13f68a__"